import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Translator } from 'ggApp/modules/translator';
import ReadMore from 'ggApp/shared/screens/ProductDetailsPage/ReadMore';
import { Item, Label, SectionTitle, Text, Wrap } from './styles';

const ProductSpecs = ({ className, list, titleTK }) => {
    const renderItem = useCallback((item) => {
        const { label, value } = item;
        return (
            <Item key={label}>
                <Label>{label}</Label>
                <Text>{value}</Text>
            </Item>
        );
    }, []);

    if (!list.length) return null;
    return (
        <ReadMore className={className}>
            <SectionTitle>
                <Translator tk={titleTK} />
            </SectionTitle>
            <Wrap>{list.map(renderItem)}</Wrap>
        </ReadMore>
    );
};

ProductSpecs.propTypes = {
    list: PropTypes.arrayOf(PropTypes.object),
    titleTK: PropTypes.string,
    className: PropTypes.string,
};

ProductSpecs.defaultProps = {
    list: [],
    titleTK: '',
    className: '',
};

export default ProductSpecs;
